import { lazy } from 'react';

export const PartnerBirthPlacePageLazy = lazy(() => import('./partner-birthplace'));
